import { useStore } from '../lib/store.ts'
import { summarize, newCard } from '../lib/srs.ts'
import { dayKey } from '../lib/time.ts'
import { plural } from '../lib/text.ts'
import { Bar, Tile } from '../components/ui.tsx'

export function StatsScreen() {
  const { idx, cards, daily, now, streak } = useStore()
  const all = idx.order.map((id) => cards.get(id) ?? newCard(id))
  const r = summarize(all, now)

  // Останні 28 днів активності.
  const days = Array.from({ length: 28 }, (_, i) => {
    const key = dayKey(now - (27 - i) * 86_400_000)
    const d = daily[key]
    return { key, count: (d?.introduced ?? 0) + (d?.reviewed ?? 0) }
  })
  const peak = Math.max(1, ...days.map((d) => d.count))
  const totalReviews = Object.values(daily).reduce((n, d) => n + d.introduced + d.reviewed, 0)
  const totalMinutes = Math.round(Object.values(daily).reduce((n, d) => n + d.seconds, 0) / 60)

  // Окремо — як ідуть хибні друзі: це найдорожчі помилки в поїздці.
  const tricky = idx.order.filter((id) =>
    (idx.phraseById.get(id)?.notes ?? []).some((n) => n.kind === 'false-friend'),
  )
  const trickyKnown = tricky.filter((id) => {
    const c = cards.get(id)
    return c && c.state === 'review' && c.interval >= 7
  }).length

  return (
    <div className="screen stack">
      <h1 style={{ paddingTop: 8 }}>Прогрес</h1>

      <div className="tiles">
        <Tile value={r.known} label="знаю впевнено" />
        <Tile value={r.learning} label="в роботі" />
        <Tile value={`${streak}🔥`} label="днів поспіль" />
      </div>

      <div className="card stack--tight stack">
        <strong>Активність за 4 тижні</strong>
        <div className="row" style={{ gap: 3, alignItems: 'flex-end', height: 92, marginTop: 6 }}>
          {days.map((d) => (
            <div
              key={d.key}
              title={`${d.key}: ${d.count}`}
              style={{
                flex: 1,
                height: `${Math.max(3, (d.count / peak) * 100)}%`,
                borderRadius: 3,
                background: d.count > 0 ? 'var(--accent)' : 'var(--bg-sunken)',
                opacity: d.count > 0 ? 0.45 + 0.55 * (d.count / peak) : 1,
              }}
            />
          ))}
        </div>
        <div className="tiny faint">Найактивніший день: {peak} {plural(peak, 'картка', 'картки', 'карток')}</div>
      </div>

      <div className="card stack--tight stack">
        <div className="row row--between">
          <strong>Хибні друзі</strong>
          <span className="muted small">{trickyKnown} з {tricky.length}</span>
        </div>
        <Bar value={trickyKnown} max={tricky.length} good={trickyKnown === tricky.length} />
        <p className="tiny faint">
          Слова на кшталт sklep, owoce, zapomnieć. Саме вони дають найдорожчі помилки,
          тому їх варто довести до кінця.
        </p>
      </div>

      <div className="card stack--tight stack">
        <strong>За весь час</strong>
        <div className="row row--between small muted"><span>Карток пройдено</span><span>{totalReviews}</span></div>
        <div className="row row--between small muted"><span>Часу за заняттями</span><span>{totalMinutes} хв</span></div>
        <div className="row row--between small muted"><span>Фраз у курсі</span><span>{idx.order.length}</span></div>
      </div>

      <a className="item" href="#/settings">
        <span className="item__emoji" aria-hidden>⚙️</span>
        <span className="item__body">
          <span className="item__title">Налаштування</span>
          <span className="item__sub">Дедлайн, транскрипція, нагадування, резервна копія</span>
        </span>
        <span className="item__after">→</span>
      </a>
    </div>
  )
}
